const titlelize = (str = '') =>
  str.trim()
     .toLowerCase()
     .replace('_', ' ')
     .replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())));

export default titlelize;
